module.exports = __webpack_public_path__ + "static/img/none3.b1ab752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/none3.png
// module id = 7Mca
// module chunks = 1